var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"count-box text-center",class:{ 'has-cursor-pointer': _vm.opens },on:{"click":_vm.open}},[_c('div',[_vm._t("marker"),_c('div',{staticClass:"count-box-value"},[(_vm.link)?_c('u',[_vm._v(_vm._s(_vm.value))]):[_vm._v(_vm._s(_vm.value))]],2),_c('div',{staticClass:"count-box-label"},[_vm._v(_vm._s(_vm.label))])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }